import React from "react";

// Outcomes whose purchase may still be a pending draft (Edit / Discard instead of View).
export const DRAFT_OUTCOMES = ["STEP1_SAVED", "DRAFT"];

/**
 * "Purchase" cell of the QR Scan Log. `state` is the resolved state of the event's purchase:
 *   "pending"   -> still a QR draft: Edit + Discard
 *   "pendingOther" -> pending but not created by QR: Edit only
 *   "completed" -> View
 *   "missing"   -> discarded/deleted: "-"
 *   undefined   -> still being checked: "…"
 */
export function QrScanPurchaseActions({event, state, onEdit, onView, onDiscard, discarding}) {
    if (!event?.purchaseId) return <>-</>;
    if (state === "missing") return <span className="text-muted" title="This purchase was discarded">-</span>;
    if (state === undefined) return <span className="text-muted">…</span>;

    if (state === "pending" || state === "pendingOther") {
        return (
            <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-sm btn-light-primary" onClick={() => onEdit(event)}>
                    Edit
                </button>
                {state === "pending" && (
                    <button
                        type="button"
                        className="btn btn-sm btn-light-danger"
                        disabled={discarding}
                        onClick={() => onDiscard(event)}
                    >
                        Discard
                    </button>
                )}
            </div>
        );
    }

    return (
        <button type="button" className="btn btn-sm btn-light-primary" onClick={() => onView(event)}>
            View
        </button>
    );
}
